import { fetchMeilisearchResults } from '../search/index.js';
export function createRequester(fetcher, requesterId) {
    function execute(fetcherParams) {
        return fetcher({
            searchClient: fetcherParams.searchClient,
            queries: fetcherParams.requests.map((x) => x.query),
        }).then((responses) => responses.map((response, index) => {
            const { sourceId, transformResponse } = fetcherParams.requests[index];
            return {
                items: response,
                sourceId,
                transformResponse,
            };
        }));
    }
    return function createSpecifiedRequester(requesterParams) {
        return function requester(requestParams) {
            return {
                requesterId,
                execute,
                ...requesterParams,
                ...requestParams,
            };
        };
    };
}
//# sourceMappingURL=createRequester.js.map